<template lang="pug">
#search-modal
  //- debug-table
  searchBar(@result="getResult")
  .search-result(v-if="loading")
    loading
  searchResult(:results="results")

</template>

<script>
import searchBar from "@/components/mobile/searchBar";
import searchResult from "@/components/mobile/searchResult";
import loading from "@/components/ui/loading";
// import debugTable from "@/components/mobile/debugTable";

export default {
  components: {
    searchBar,
    searchResult,
    loading,
    // debugTable
  },
  data() {
    return {
      results: {},
      loading: false
    };
  },
  computed: {
    search() {
      return this.$store.getters.search;
    },
    match() {
      return this.$store.state.cache.match;
    }
  },
  watch: {
    search(newVal) {
      this.getResult(this.search);
    }
  },
  mounted() {
    if(this.search) {
      this.getResult(this.search);
    }
  },
  methods: {
    getResult(e) {
      if (e != null && e != "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.results = this.match;
        }, 5000);
      } else {
        this.results = {};
      }
    }
  }
};
</script>
